import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[onlyNumber]'
})
export class OnlyNumberDirective {
  private regex: RegExp = new RegExp(/^[0-9]*$/g);
  private specialKeys: Array<string> = [ 'Backspace', 'Tab', 'End', 'Home', 'Delete', 'ArrowLeft', 'ArrowRight' ];

  @Input() onlyNumber = false;

  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', [ '$event' ])
  onKeyDown(event: KeyboardEvent) {
    if (!this.onlyNumber) {
      return;
    }
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const current: string = this.el.nativeElement.value;
    const next = `${current || ''}${event.key}`;
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/only-number.directive.ts